import React, { useEffect, useState } from 'react';
import { Form, Modal, Toast } from 'react-bootstrap';
import { useAuthContext } from '../context/authContext';
import { updateLoggedInUserPassword } from '../context/authContext/authActions';

import appStyle from '../styles/App.module.scss';
import CustomButton from './CustomButton';

const UserChangePassword = (props) => {
  const { dispatch } = useAuthContext();
  const [inputs, setInputs] = useState({ password: '', confirm_password: '' });
  const [showToast, setShowToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleToggleToast = (e) => {
    setShowToast(!showToast);
  };

  const handleClose = (e) => {
    props.handleClose();
  };

  useEffect(() => {
    setErrorMessage('');
    setInputs({ password: '', confirm_password: '' }); // Reset inputs
  }, [props.show]);


  const validatePasswordComplexity = (password) => {
    // Better validation, to implement in August 2024
    // const complexityRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    // Old validation
    const complexityRegex = /^.{6,}$/;
    return complexityRegex.test(password);
  };

  const handlePasswordSave = async (e) => {
    e.preventDefault();

    if (inputs.password !== inputs.confirm_password) {
      setErrorMessage("The password and confirmation password do not match.");
      return;
    }

    if (!validatePasswordComplexity(inputs.password)) {
      // Better validation, to implement in August 2024
      // setErrorMessage(
      //   'Password complexity requirement not met. Must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character.'
      // );

      setErrorMessage(
        'Password should be at least 6 characters long.'
      );

      return;
    }

    const result = await updateLoggedInUserPassword(dispatch, {
      user_id: props.user.id,
      request_body: {
        user: {
          password: inputs['password'],
        },
      },
    });

    if (result && result.success) {
      props.handleClose();
      setErrorMessage('');  // Clear any previous error messages
      setShowToast(true);   // Show success toast
    } else if (result) {
      setErrorMessage(result.message);
    } else {
      setErrorMessage('An unexpected error occurred.');
    }
  };

  return (
    <>
      <Modal show={props.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='font-poppins'>Change password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handlePasswordSave}>
            <div className={appStyle['b-form-body']}>
              <Form.Group
                controlId="formBasicPassword"
                className={appStyle['custom-form-group']}
              >
                <Form.Label className={appStyle['form-custom-label']}>
                  New password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  required
                  value={inputs['password']}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group
                controlId="formBasicPasswordConfirmation"
                className={appStyle['custom-form-group']}
              >
                <Form.Label className={appStyle['form-custom-label']}>
                  Confirm new password
                </Form.Label>
                <Form.Control
                  type="password"
                  name="confirm_password"
                  required
                  value={inputs['confirm_password']}
                  onChange={handleInputChange}
                />
              </Form.Group>
              {errorMessage && (
                <div className={`text-center`} style={{ color: 'red', marginBottom: '10px' }}>
                  {errorMessage}
                </div>
              )}
            </div>
            <CustomButton
              label="Submit"
              className='custom-button-default'
            />
          </Form>
        </Modal.Body>
      </Modal>

      <Toast
        show={showToast}
        onClose={handleToggleToast}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        <Toast.Header>
          <strong className="rounded mr-4">Password change</strong>
        </Toast.Header>
        <Toast.Body>Your password has been changed successfully!</Toast.Body>
      </Toast>
    </>
  );
};

export default UserChangePassword;
